<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">ALL PAID BILLS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Paid Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Card -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card bg-primary text-white">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-8">
                        <h5 class="text-white mb-1">Total Collected Revenue</h5>
                        <h2 class="text-white mb-0">{{ formatPrice(summary.total || 0) }}</h2>
                      </div>
                      <div class="col-4 text-end">
                        <div class="badge bg-light text-primary fs-6 px-3 py-2">
                          {{ numberFormat(summary.count || 0) }} Transactions
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">All Paid Bills</h4>
                      <div>
                        <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Create A Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Payment Method Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Payment Method:</label>
                        <select v-model="paymentMethod" @change="getReceiptsDetailsPaginated()" class="form-select">
                          <option value="">All Methods</option>
                          <option value="MPESA">MPESA</option>
                          <option value="BANK">BANK</option>
                        </select>
                      </div>

                      <!-- Revenue Stream Filter -->
                      <div class="col-md-3">
                        <label class="form-label mb-1">Revenue Stream:</label>
                        <select v-model="selectedStream" @change="getReceiptsDetailsPaginated()" class="form-select">
                          <option value="">All Streams</option>
                          <option v-for="stream in streams" :key="stream.id" :value="stream.incomeTypePrefix">
                            {{ stream.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-7">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search... eg Business Name, ID Number, Bill Number, etc"
                                 @input="debounceSearch">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Location and Date Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-end">
                      <!-- Location Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Sub County:</label>
                        <select class="form-select" v-model="subCounty" @change="handleSubCountyChange">
                          <option value="">All Sub Counties</option>
                          <option v-for="item in subCounties" :key="item.subCountyID" :value="item">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Ward:</label>
                        <select class="form-select" v-model="ward" @change="handleWardChange">
                          <option value="">All Wards</option>
                          <option v-for="item in wards" :key="item.wardID" :value="item">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Zone:</label>
                        <select class="form-select" v-model="zone" @change="handleZoneChange">
                          <option value="">All Zones</option>
                          <option v-for="item in zones" :key="item.zone" :value="item.zone">
                            {{ item.zone }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Attendant:</label>
                        <select class="form-select" v-model="selectedUser" @change="getReceiptsDetailsPaginated()">
                          <option value="">All Attendants</option>
                          <option v-for="item in users" :key="item.idNo" :value="item.idNo">
                            {{ item.names }}
                          </option>
                        </select>
                      </div>

                      <!-- Date Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">From:</label>
                        <input v-model="dateFrom" class="form-control" type="date" @change="handleDateChange">
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">To:</label>
                        <input v-model="dateTo" class="form-control" type="date" @change="handleDateChange">
                      </div>
                    </div>

                    <!-- Export Buttons -->
                    <div class="mt-3">
                      <div class="btn-group" role="group">
                        <!-- Export Current Page -->
                        <button v-if="getRight('DOWNLOAD PAID INVOICES')"
                                @click="exportToCSV()"
                                type="button"
                                class="btn btn-success"
                                :disabled="exporting || billDetails.length === 0">
                          <i class="bx bxs-file-export font-size-16"></i>
                          <span class="ms-1">Current Page ({{ billDetails.length }})</span>
                        </button>

                        <!-- Export All Records with Progress -->
                        <button v-if="getRight('DOWNLOAD PAID INVOICES')"
                                @click="exportAllData()"
                                type="button"
                                class="btn btn-primary"
                                :disabled="exportingAll || summary.count === 0">
                          <span v-if="exportingAll">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Exporting...
                          </span>
                          <span v-else>
                            <i class="bx bx-cloud-download font-size-16"></i>
                            <span class="ms-1">Export All ({{ numberFormat(summary.count) }})</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap">Transaction Code</th>
                          <th class="text-nowrap" style="min-width: 200px;">Description</th>
                          <th class="text-nowrap">Location</th>
                          <th class="text-nowrap">Attendant</th>
                          <th class="text-nowrap text-end">Billed Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Payment</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in billDetails" :key="item.id || index">
                          <td class="text-nowrap">{{ ((currentPage - 1) * actualPageSize) + index + 1 }}</td>
                          <td class="text-nowrap">
                            <span class="fw-semibold text-primary">{{ item.billNo || item.account_ref || 'N/A' }}</span>
                          </td>
                          <td class="text-nowrap">
                            <span class="badge bg-info">{{ item.transactionCode || item.transaction_code || item.receiptNo || 'N/A' }}</span>
                          </td>
                          <td style="min-width: 200px;">
                            <div>
                              <strong>{{ item.incomeTypeDescription || item.description || item.transaction_desc || 'N/A' }}</strong>
                              <small class="text-muted d-block">{{ item.feeDescription || '' }}</small>
                              <small class="text-muted d-block">{{ item.paidBy || item.names || '' }}</small>
                              <small class="text-muted d-block">{{ maskPhoneNumber(item.idNo) || '' }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <div>
                              <div>{{ item.subCountyName || 'N/A' }}</div>
                              <small class="text-muted">{{ item.wardName || '' }}</small>
                              <small class="text-muted d-block">{{ item.zone || '' }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">{{ item.receiptedBy || item.createdBy || item.username || '' }}</td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.detailAmount || item.amount || 0) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold text-success">{{ formatPrice(item.receiptAmount || item.amount || 0) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold" :class="{'text-danger': item.billBalance > 0}">
                              {{ formatPrice(item.billBalance || 0) }}
                            </span>
                          </td>
                          <td class="text-nowrap">
                            <span class="badge" :class="getPaymentBadgeClass(item.source || item.payment_type)">
                              {{ item.source || item.payment_type || 'N/A' }}
                            </span>
                          </td>
                          <td>
                            <span class="badge" :class="getStatusBadgeClass(item.status)">
                              {{ item.status || 'UNPAID' }}
                            </span>
                          </td>
                          <td class="text-nowrap">{{ formatDate(item.dateCreated || item.date) }}</td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="viewBillDetails(item)"
                                      class="btn btn-primary btn-sm me-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#paidBillModal">
                                View
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li>
                                    <a class="dropdown-item" href="#" @click.prevent="printReceipt(item)">
                                      <i class="mdi mdi-printer me-2"></i>Print Receipt
                                    </a>
                                  </li>
                                  <li>
                                    <a  v-if="getRight('EMAIL RECEIPT')" class="dropdown-item" href="#" @click.prevent="emailReceipt(item)">
                                      <i class="mdi mdi-email me-2"></i>Email Receipt
                                    </a>
                                  </li>
                                  <li>
                                    <a v-if="getRight('SMS RECEIPT')" class="dropdown-item" href="#" @click.prevent="smsReceipt(item)">
                                      <i class="mdi mdi-chat me-2"></i>SMS Receipt
                                    </a>
                                  </li>
                                  <li v-if="getRight('VOID RECEIPT')">
                                    <hr class="dropdown-divider">
                                  </li>
                                  <li v-if="getRight('VOID RECEIPT')">
                                    <a class="dropdown-item text-danger" href="#" @click.prevent="voidReceipt(item)">
                                      <i class="mdi mdi-cancel me-2"></i>Void Receipt
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="6" class="text-end">{{ summary.count || 0 }} Paid Bills</th>
                          <th class="text-end">{{ formatPrice(totalDetailAmount) }}</th>
                          <th class="text-end">{{ formatPrice(totalReceiptAmount) }}</th>
                          <th class="text-end">{{ formatPrice(totalBillBalance) }}</th>
                          <th colspan="4"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-info mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Data</h4>
                        <p>We are fetching the data for you. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="billDetails.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Results To Show</h4>
                        <p>{{ emptyStateMessage }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white" v-if="billDetails.length > 0">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize" @change="handlePageSizeChange">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="200">200 Rows</option>
                          <option value="500">500 Rows</option>
                          <option value="1000">1000 Rows</option>
                        </select>
                        <span class="ms-3 text-muted">
                          Showing {{ paginationStart }} to {{ paginationEnd }} of {{ summary.count }} entries
                        </span>
                      </div>

                      <ul class="pagination mb-0" v-if="pageSize !== 'all'">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in visiblePages" :key="'page-' + page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Export Progress Modal with Pause/Resume and Time Estimation -->
        <div class="modal fade" id="exportProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title text-white">
                  <i class="bx bxs-download me-2"></i>Exporting All Records
                </h5>
              </div>
              <div class="modal-body">
                <div class="text-center mb-3">
                  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!exportPaused">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else class="mb-3">
                    <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                  </div>
                  <h5 v-if="!exportPaused">Please wait while we export your records...</h5>
                  <h5 v-else class="text-warning">Export Paused</h5>

                  <!-- Estimated Time Remaining -->
                  <div v-if="exportProgress.estimatedTimeRemaining && !exportPaused" class="mt-2">
                    <p class="text-muted mb-1">
                      <i class="bx bx-time-five me-1"></i>
                      <strong>{{ formatTimeRemaining(exportProgress.estimatedTimeRemaining) }}</strong> remaining
                    </p>
                    <small class="text-muted">
                      Average speed: {{ exportProgress.averageSpeed }} records/sec
                    </small>
                  </div>

                  <p class="text-muted mt-2">{{ exportPaused ? 'You can resume or cancel the export.' : 'This may take several minutes depending on the amount of data.' }}</p>
                </div>

                <div class="progress mb-3" style="height: 25px;">
                  <div
                      class="progress-bar progress-bar-striped"
                      :class="{'progress-bar-animated': !exportPaused, 'bg-warning': exportPaused}"
                      role="progressbar"
                      :style="{ width: exportProgress.percentage + '%' }"
                      :aria-valuenow="exportProgress.percentage"
                      aria-valuemin="0"
                      aria-valuemax="100">
                    {{ exportProgress.percentage }}%
                  </div>
                </div>

                <div class="d-flex justify-content-between text-muted small mb-3">
                  <span>Page {{ exportProgress.current }} of {{ exportProgress.total }}</span>
                  <span>{{ exportProgress.records }} / {{ numberFormat(exportProgress.totalRecords) }} records</span>
                </div>

                <!-- Error Display -->
                <div v-if="exportError" class="alert alert-danger d-flex align-items-center" role="alert">
                  <i class="bx bx-error-circle me-2"></i>
                  <div class="flex-grow-1">
                    <strong>Error:</strong> {{ exportError }}
                    <br>
                    <small>You can retry from where it stopped or cancel the export.</small>
                  </div>
                </div>

                <!-- Retry Count Display -->
                <div v-if="exportRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>Retry attempt {{ exportRetryCount }} of 3</small>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex gap-2 justify-content-center mb-3">
                  <button
                      v-if="!exportPaused && !exportError"
                      @click="pauseExport"
                      class="btn btn-warning btn-sm">
                    <i class="bx bx-pause me-1"></i>Pause
                  </button>
                  <button
                      v-if="exportPaused || exportError"
                      @click="resumeExport"
                      class="btn btn-success btn-sm">
                    <i class="bx bx-play me-1"></i>Resume
                  </button>
                  <button
                      @click="cancelExport"
                      class="btn btn-danger btn-sm">
                    <i class="bx bx-x me-1"></i>Cancel
                  </button>
                </div>

                <div class="alert alert-info d-flex align-items-center" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>{{ exportPaused ? 'Export is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
                </div>

                <!-- Export Statistics -->
                <div v-if="exportProgress.records > 0" class="mt-3 pt-3 border-top">
                  <div class="row text-center">
                    <div class="col-4">
                      <small class="text-muted d-block">Exported</small>
                      <strong>{{ numberFormat(exportProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Remaining</small>
                      <strong>{{ numberFormat(exportProgress.totalRecords - exportProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Success Rate</small>
                      <strong>{{ getSuccessRate() }}%</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Paid Bill Detail Modal -->
        <PaidBillModal
            :billDetail="billDetail"
            :billInfo="billInfo"
            :billNo="billNo"
            @print-receipt="printReceipt"
        />

        <!-- Alert for actions -->
        <div v-if="alert.success || alert.failed || alert.info" class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
                'bg-success text-white': alert.success,
                'bg-danger text-white': alert.failed,
                'bg-info text-white': alert.info
              }">
              <strong class="me-auto">Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import PaidBillModal from "@/components/invoices/modals/PaidBillModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "AllPaidBills",
  components: {
    NavigationBar,
    PaidBillModal
  },
  data() {
    return {
      // Loading states
      loading: false,
      exporting: false,
      exportingAll: false,
      searchTimeout: null,

      // Pagination
      currentPage: 1,
      totalPages: 1,
      pageSize: '25',

      // Filters
      search: '',
      paymentMethod: '',
      selectedStream: '',
      dateFrom: '',
      dateTo: '',

      // Location filters
      subCounty: '',
      ward: '',
      zone: '',
      selectedUser: '',

      // Data
      billDetails: [],
      allBillDetails: [],
      billInfo: [],
      billDetail: {},
      billNo: '',

      // Dropdown data
      subCounties: [],
      wards: [],
      zones: [],
      users: [],
      streams: [],

      // Summary
      summary: { count: 0, total: 0 },

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',
      emptyStateMessage: 'Sorry, we could not find any results that match your search or filter criteria.',

      // Export All functionality with pause/resume and time estimation
      exportPaused: false,
      exportCancelled: false,
      exportError: null,
      exportRetryCount: 0,
      maxRetries: 3,
      exportProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allExportData: [],
      exportState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },
  computed: {
    actualPageSize() {
      return this.pageSize === 'all' ? null : parseInt(this.pageSize);
    },

    totalReceiptAmount() {
      const total = this.billDetails.reduce((sum, item) =>
          sum + parseFloat(item.receiptAmount || item.amount || 0), 0
      );
      return total;
    },

    totalBillBalance() {
      const total = this.billDetails.reduce((sum, item) =>
          sum + parseFloat(item.billBalance || 0), 0
      );
      return total;
    },

    totalDetailAmount() {
      const total = this.billDetails.reduce((sum, item) =>
          sum + parseFloat(item.detailAmount || item.amount || 0), 0
      );
      return total;
    },

    visiblePages() {
      return this.pagination(this.currentPage, this.totalPages, 5);
    },

    paginationStart() {
      if (this.billDetails.length === 0) return 0;
      return ((this.currentPage - 1) * (this.actualPageSize || this.billDetails.length)) + 1;
    },

    paginationEnd() {
      if (this.pageSize === 'all') return this.summary.count;
      const end = this.currentPage * this.actualPageSize;
      return Math.min(end, this.summary.count);
    }
  },
  mounted() {
    // Set default date range
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    // Load initial data
    this.loadInitialData();
  },
  methods: {
    getRight,

    // Initialize all data
    async loadInitialData() {
      await Promise.all([
        this.getAvailableStreams(),
        this.getSubCounties(),
        this.menuAccess()
      ]);
      await this.getReceiptsDetailsPaginated();
    },

    // Utility methods
    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD MMM YYYY');
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    // Format time remaining in human-readable format
    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    // Calculate estimated time remaining
    calculateEstimatedTime() {
      if (!this.exportProgress.startTime || this.exportProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.exportProgress.startTime) / 1000;
      const recordsDownloaded = this.exportProgress.records;
      const remainingRecords = this.exportProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.exportProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.exportProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    // Get Success Rate
    getSuccessRate() {
      if (this.exportProgress.total === 0) return 100;
      const successfulPages = this.exportProgress.current - this.exportRetryCount;
      return Math.round((successfulPages / this.exportProgress.total) * 100);
    },

    // Pause Export
    pauseExport() {
      this.exportPaused = true;
      console.log('Export paused at page:', this.exportState.currentPage);
    },

    // Resume Export
    async resumeExport() {
      this.exportPaused = false;
      this.exportError = null;
      this.exportRetryCount = 0;

      console.log('Resuming export from page:', this.exportState.currentPage + 1);

      await this.continueExport();
    },

    // Cancel Export
    cancelExport() {
      const confirmed = confirm('Are you sure you want to cancel the export? All progress will be lost.');

      if (confirmed) {
        this.exportCancelled = true;
        this.closeExportModal();
      }
    },

    // Close Export Modal
    closeExportModal() {
      const modalElement = document.getElementById('exportProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Reset state
      this.exportingAll = false;
      this.exportPaused = false;
      this.exportCancelled = false;
      this.exportError = null;
      this.exportRetryCount = 0;
      this.allExportData = [];
      this.exportProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.exportState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    // Main data loading method
    async getReceiptsDetailsPaginated() {
      this.loading = true;
      this.billDetails = [];

      try {
        const data = new FormData();
        data.append("function", "getReceiptsDetailsPaginated");
        data.append("page", this.currentPage);

        if (this.actualPageSize) {
          data.append("rows_per_page", this.actualPageSize);
        }

        data.append("status", "PAID");

        if (this.paymentMethod) {
          data.append("payment_method", this.paymentMethod);
        }

        if (this.dateFrom && this.dateTo) {
          data.append("dateFrom", this.dateFrom);
          data.append("dateTo", this.dateTo);
        }

        if (this.search) {
          data.append("keyword", this.search);
        }

        if (this.subCounty) {
          data.append("subCountyID", this.subCounty.subCountyID);
          data.append("subCountyName", this.subCounty.subCountyName);
        }

        if (this.ward) {
          data.append("wardID", this.ward.wardID);
          data.append("wardName", this.ward.wardName);
        }

        if (this.zone) {
          data.append("zone", this.zone);
        }

        if (this.selectedUser) {
          data.append("createdBy", this.selectedUser);
        }

        if (this.selectedStream) {
          data.append("incomeTypePrefix", this.selectedStream);
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.billDetails = response.data.data.billDetails || [];
          this.summary = response.data.data.summary || { count: 0, total: 0 };

          if (this.actualPageSize) {
            this.totalPages = Math.ceil(this.summary.count / this.actualPageSize);
          } else {
            this.totalPages = 1;
          }

          this.updateEmptyStateMessage();
        } else {
          this.showAlert('failed', response.data.message || 'Failed to load receipts');
        }
      } catch (error) {
        console.error('Error loading receipts:', error);
        this.showAlert('failed', 'An error occurred while loading receipts');
      } finally {
        this.loading = false;
      }
    },

    // Export current page data to CSV
    exportToCSV() {
      if (this.billDetails.length === 0) {
        this.showAlert('info', 'No data to export');
        return;
      }

      this.exporting = true;

      try {
        const csvContent = this.generateCSVContent(this.billDetails);
        this.downloadCSV(csvContent, this.generateFileName('current_page'));
        this.showAlert('success', `Successfully exported ${this.billDetails.length} records to CSV`);
      } catch (error) {
        console.error('Export error:', error);
        this.showAlert('failed', 'Failed to export data');
      } finally {
        this.exporting = false;
      }
    },

    // Export all data with pause/resume functionality
    async exportAllData() {
      if (this.summary.count === 0) {
        this.showAlert('info', 'No data to export');
        return;
      }

      const isConfirmed = confirm(
          `You are about to export all ${this.numberFormat(this.summary.count)} records from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.exportingAll = true;
      this.exportPaused = false;
      this.exportCancelled = false;
      this.exportError = null;
      this.exportRetryCount = 0;
      this.allExportData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.exportState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.exportProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('exportProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueExport();
    },

    // Continue Export (used by both initial export and resume)
    async continueExport() {
      try {
        const startPage = this.exportState.currentPage + 1;
        const totalPages = this.exportState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.exportPaused) {
            console.log('Export paused, waiting for resume...');
            return;
          }

          if (this.exportCancelled) {
            console.log('Export cancelled by user');
            return;
          }

          try {
            this.exportState.currentPage = page;
            this.exportProgress.current = page;
            this.exportProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchExportPageWithRetry(page, this.exportState.batchSize);

            if (pageData && pageData.length > 0) {
              this.exportState.accumulatedData = [...this.exportState.accumulatedData, ...pageData];
              this.allExportData = this.exportState.accumulatedData;
              this.exportProgress.records = this.allExportData.length;

              this.calculateEstimatedTime();
            }

            this.exportRetryCount = 0;
            this.exportError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.exportError = error.message;
            this.exportPaused = true;
            return;
          }
        }

        await this.finalizeExport();

      } catch (error) {
        console.error('Export error:', error);
        this.exportError = error.message;
        this.exportPaused = true;
      }
    },

    // Fetch Export Page with Retry Logic
    async fetchExportPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getReceiptsDetailsPaginated");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("status", "PAID");

        if (this.paymentMethod) data.append("payment_method", this.paymentMethod);
        if (this.dateFrom && this.dateTo) {
          data.append("dateFrom", this.dateFrom);
          data.append("dateTo", this.dateTo);
        }
        if (this.search) data.append("keyword", this.search);
        if (this.subCounty) data.append("subCountyID", this.subCounty.subCountyID);
        if (this.ward) data.append("wardID", this.ward.wardID);
        if (this.zone) data.append("zone", this.zone);
        if (this.selectedUser) data.append("createdBy", this.selectedUser);
        if (this.selectedStream) data.append("incomeTypePrefix", this.selectedStream);

        const res = await execute(data, biller);

        if (res.data.success) {
          return res.data.data.billDetails || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.exportRetryCount = retryCount + 1;
          console.log(`Retry ${this.exportRetryCount} for page ${page}`);

          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);

          return this.fetchExportPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    // Finalize Export
    async finalizeExport() {
      if (this.allExportData.length > 0) {
        const csv = this.generateCSVContent(this.allExportData);

        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = this.generateFileName('all_data');

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        this.showAlert('success', `Successfully exported ${this.allExportData.length} records!`);

        this.closeExportModal();
      } else {
        this.showAlert('info', 'No records found to export');
        this.closeExportModal();
      }
    },

    // Delay helper function
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // Generate CSV content - WITH field fallbacks
    generateCSVContent(data) {
      const headers = [
        'Transaction No',
        'Bill No',
        'Transaction Code',
        'Receipt No',
        'Description',
        'Fee Description',
        'Customer Name',
        'Customer ID',
        'Sub County',
        'Ward',
        'Zone',
        'Attendant',
        'Billed Amount',
        'Amount Paid',
        'Balance',
        'Payment Method',
        'Status',
        'Transaction Date',
        'Revenue Stream'
      ];

      const rows = data.map((item, index) => {
        return [
          index + 1,
          this.escapeCSV(item.billNo || item.account_ref || ''),
          this.escapeCSV(item.transactionCode || item.transaction_code || ''),
          this.escapeCSV(item.receiptNo || ''),
          this.escapeCSV(item.incomeTypeDescription || item.description || item.transaction_desc || ''),
          this.escapeCSV(item.feeDescription || ''),
          this.escapeCSV(item.paidBy || item.names || ''),
          this.escapeCSV(item.idNo || ''),
          this.escapeCSV(item.subCountyName || ''),
          this.escapeCSV(item.wardName || ''),
          this.escapeCSV(item.zone || ''),
          this.escapeCSV(item.createdBy || item.username || 'System'),
          this.formatNumber(item.detailAmount || item.amount || 0),
          this.formatNumber(item.receiptAmount || item.amount || 0),
          this.formatNumber(item.billBalance || 0),
          this.escapeCSV(item.source || item.payment_type || ''),
          this.escapeCSV(item.status || 'UNPAID'),
          this.formatDateForExport(item.dateCreated || item.date),
          this.escapeCSV(item.incomeTypePrefix || '')
        ];
      });

      rows.push([]);
      rows.push([
        'TOTALS',
        '',
        '',
        '',
        '',
        '',
        `${data.length} Transactions`,
        '',
        '',
        '',
        '',
        '',
        this.formatNumber(data.reduce((sum, item) => sum + parseFloat(item.detailAmount || item.amount || 0), 0)),
        this.formatNumber(data.reduce((sum, item) => sum + parseFloat(item.receiptAmount || item.amount || 0), 0)),
        this.formatNumber(data.reduce((sum, item) => sum + parseFloat(item.billBalance || 0), 0)),
        '',
        '',
        '',
        ''
      ]);

      const metadata = [
        ['PAID BILLS REPORT'],
        ['Generated on:', moment().format('DD/MM/YYYY HH:mm:ss')],
        ['Date Range:', `${this.dateFrom} to ${this.dateTo}`],
        ['Filters Applied:'],
        ['Payment Method:', this.paymentMethod || 'All'],
        ['Revenue Stream:', this.getStreamName(this.selectedStream) || 'All'],
        ['Sub County:', this.subCounty?.subCountyName || 'All'],
        ['Ward:', this.ward?.wardName || 'All'],
        ['Zone:', this.zone || 'All'],
        ['Attendant:', this.getUserName(this.selectedUser) || 'All'],
        ['Search Keyword:', this.search || 'None'],
        [],
        []
      ];

      const allRows = [...metadata, headers, ...rows];

      return allRows.map(row => row.join(',')).join('\n');
    },

    // Utility function to escape CSV values
    escapeCSV(value) {
      if (value === null || value === undefined) return '';

      const stringValue = String(value);

      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    },

    formatNumber(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2);
    },

    formatDateForExport(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
    },

    generateFileName(type, extension = 'csv') {
      const timestamp = moment().format('YYYYMMDD_HHmmss');
      const dateRange = `${this.dateFrom}_to_${this.dateTo}`;
      return `paid_bills_${type}_${dateRange}_${timestamp}.${extension}`;
    },

    downloadCSV(content, filename) {
      const blob = new Blob(['\ufeff' + content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    getStreamName(prefix) {
      const stream = this.streams.find(s => s.incomeTypePrefix === prefix);
      return stream ? stream.name : prefix;
    },

    getUserName(idNo) {
      const user = this.users.find(u => u.idNo === idNo);
      return user ? user.names : idNo;
    },

    // Filter handlers
    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.getReceiptsDetailsPaginated();
      }, 500);
    },

    handleSubCountyChange() {
      this.getWards();
      this.currentPage = 1;
      this.getReceiptsDetailsPaginated();
    },

    handleWardChange() {
      if (this.ward) {
        this.getZones(this.ward.wardID, this.ward.wardName);
      }
      this.currentPage = 1;
      this.getReceiptsDetailsPaginated();
    },

    handleZoneChange() {
      if (this.zone) {
        this.getUsers(this.zone);
      }
      this.currentPage = 1;
      this.getReceiptsDetailsPaginated();
    },

    handleDateChange() {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1;
        this.getReceiptsDetailsPaginated();
      }
    },

    handlePageSizeChange() {
      this.currentPage = 1;
      this.getReceiptsDetailsPaginated();
    },

    // Load dropdown data
    async getAvailableStreams() {
      try {
        const data = new FormData();
        data.append("function", "getAvailableStreams");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.streams = res.data.data.streams || [];
        }
      } catch (e) {
        console.error('Error loading streams:', e);
      }
    },

    async getSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties || [];
        }
      } catch (e) {
        console.error('Error loading sub-counties:', e);
      }
    },

    async getWards() {
      this.wards = [];
      this.ward = '';

      if (!this.subCounty?.subCountyID) return;

      try {
        const data = new FormData();
        data.append("function", "getWards");
        data.append("subCountyID", this.subCounty.subCountyID);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.wards = res.data.data.wards || [];
        }
      } catch (e) {
        console.error('Error loading wards:', e);
      }
    },

    async getZones(wardID, wardName) {
      this.zones = [];

      if (!wardID) return;

      try {
        const data = new FormData();
        data.append("function", "getZones");
        data.append("wardID", wardID);

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.zones = res.data.data.zones || [];
        }
      } catch (e) {
        console.error('Error loading zones:', e);
      }
    },

    async getUsers(zone) {
      this.users = [];

      try {
        const data = new FormData();
        data.append("function", "getUsers");
        if (zone) {
          data.append("search", zone);
        }

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.users = res.data.data.users || [];
        }
      } catch (e) {
        console.error('Error loading users:', e);
      }
    },

    // View bill details - WITH field fallbacks
    async viewBillDetails(item) {
      this.billDetail = {...item};
      this.billNo = item.billNo || item.account_ref;

      if (this.billNo) {
        await this.getBill(this.billNo);
      }
    },

    async getBill(billNo) {
      try {
        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.billInfo = res.data.data.billInfo || [];
          Object.assign(this.billDetail, res.data.data.billDetails || {});
        }
      } catch (e) {
        console.error('Error loading bill details:', e);
      }
    },

    // Actions - WITH field fallbacks
    printReceipt(item) {
      const receipt = item || this.billDetail;
      const receiptNo = receipt.transactionCode || receipt.transaction_code || receipt.receiptNo;
      const billNo = receipt.billNo || receipt.account_ref;

      if (!receiptNo) {
        this.showAlert('failed', "Receipt number not available");
        return;
      }

      localStorage['params'] = JSON.stringify({
        receiptNo: receiptNo,
        billNo: billNo
      });

      const routeData = this.$router.resolve({ name: 'receipt' });
      window.open(routeData.href, '_blank');
    },

    emailReceipt(item) {
      console.log('Email receipt for', item);
      this.showAlert('info', 'Email functionality coming soon');
    },

    smsReceipt(item) {
      console.log('SMS receipt for', item);
      this.showAlert('info', 'SMS functionality coming soon');
    },

    // Void receipt - WITH field fallbacks
    async voidReceipt(item) {
      const receiptNo = item.transactionCode || item.transaction_code || item.receiptNo;

      if (!confirm(`Are you sure you want to void receipt ${receiptNo}?`)) {
        return;
      }

      try {
        const data = new FormData();
        data.append("function", "voidReceipt");
        data.append("receiptNo", receiptNo);
        data.append("reason", "Voided by user");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.showAlert('success', 'Receipt voided successfully');
          await this.getReceiptsDetailsPaginated();
        } else {
          this.showAlert('failed', res.data.message || 'Failed to void receipt');
        }
      } catch (e) {
        console.error('Error voiding receipt:', e);
        this.showAlert('failed', 'An error occurred while voiding receipt');
      }
    },

    getPaymentBadgeClass(method) {
      const classes = {
        'MPESA': 'bg-success',
        'BANK': 'bg-info',
        'CARD': 'bg-primary'
      };
      return classes[method] || 'bg-secondary';
    },

    getStatusBadgeClass(status) {
      const classes = {
        'PAID': 'bg-success',
        'PARTIAL': 'bg-warning',
        'PENDING': 'bg-info',
        'UNPAID': 'bg-danger',
        'VOIDED': 'bg-dark'
      };
      return classes[status] || 'bg-secondary';
    },

    updateEmptyStateMessage() {
      let message = 'No receipts found';

      if (this.search) {
        message += ` matching "${this.search}"`;
      }
      if (this.paymentMethod) {
        message += ` for ${this.paymentMethod} payments`;
      }
      if (this.selectedStream) {
        message += ` in selected revenue stream`;
      }
      if (this.dateFrom && this.dateTo) {
        message += ` between ${this.formatDate(this.dateFrom)} and ${this.formatDate(this.dateTo)}`;
      }

      this.emptyStateMessage = message + '.';
    },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "All Paid Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    },

    gotTo(route) {
      this.$router.push(route);
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = Math.min(start + maxVisibleButtons - 1, totalPages);
      }

      if (end > totalPages) {
        end = totalPages;
        start = Math.max(end - maxVisibleButtons + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
        pages.unshift(1);
      }

      if (end < totalPages) {
        pages.push("...");
        pages.push(totalPages);
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getReceiptsDetailsPaginated();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getReceiptsDetailsPaginated();
      }
    },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
        this.getReceiptsDetailsPaginated();
      }
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.toast-container {
  z-index: 9999;
}

.text-success {
  color: #198754 !important;
}

.text-primary {
  color: #0d6efd !important;
}

.bg-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.btn-group .btn {
  white-space: nowrap;
}

.btn-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Progress modal styling */
#exportProgressModal .modal-body {
  padding: 2rem;
}

#exportProgressModal .progress {
  background-color: #e9ecef;
}

#exportProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

/* Pause icon animation */
.bx-pause-circle {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Time remaining display */
.text-muted strong {
  color: #495057;
  font-weight: 600;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>